<template>
  <div class="cashflow-type-fixed card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :recommended-or-expected-amount="fixedExpenses.recommendedOrExpectedAmount"
                      :recommended-or-expected-label="titles.expenseProgress.recommendedLabel"
                      :up-to-now-label="titles.expenseProgress.actualsLabel"
                      :up-to-now-amount="fixedExpenses.upToNowAmount"
                      :show-warning-if-exceeding-budget="false"/>

    <predicted-category-sections :actuals-title="titles.categorySections.actualsTitle"
                                 :recommended-title="titles.categorySections.recommendedTitle"
                                 :categories="fixedExpenses.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="true"
                                 :title="titles.categorySections.mainTitle"
                                 :expense-category="titles.cashflowType"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <predicted-transaction class="transaction-details"
                                     v-for="transaction in transactions"
                                     :predicted-transaction="transaction"
                                     :canEditCategory="true"
                                     :showPrediction="true"
                                     :category-name="CASHFLOW_TYPE"
                                     v-bind:key="transaction.transactionId">

          </predicted-transaction>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';
import PredictedTransaction from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedTransaction.vue';

export default {
  name: 'CashflowTypeFixedExpense',
  mixins: [CashflowAnalytics],
  components: {
    ExpenseProgress,
    PredictedTransaction,
    PredictedCategorySections,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    CASHFLOW_TYPE() {
      return cashflowViewConsts.cashflowTypes.fixedExpense;
    },
    fixedExpenses() {
      return this.cashflowUITree[this.CASHFLOW_TYPE];
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'יצא עד עכשיו',
          recommendedLabel: 'סה"כ צפוי לצאת',
        },
        categorySections: {
          actualsTitle: 'יצא',
          recommendedTitle: 'צפוי לצאת',
          mainTitle: 'פירוט הוצאות קבועות',
        },
        cardTitle: 'הוצאות קבועות',
        cashflowType: 'קבועות',
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-fixed {
    @include cashflow-card;

    .title {
      @include cashflow-card-title;
    }
    .cashflow-type-color {
      color: $riseup_red;
    }

    .cashflow-type-background-color {
      background-color: $riseup_red;
    }
  }

</style>
